import { invitationMembershipPath } from '~/utils/assessmentInvitation'

export default function({ store, redirect, route }) {
	if (store.getters['user/loggedIn']) {
		const membershipPath = /^\/auth\/register\/?$/.test(route?.path || '')
			? invitationMembershipPath(route.query)
			: null
		return redirect(membershipPath || '/')
	}
}
